import React, { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/circle-wellness-care-logo.png'; // Import logo

const Navigation = () => {
  const location = useLocation();
  const [active, setActive] = useState(null);

  const handleMouseEnter = (path) => setActive(path);
  const handleMouseLeave = () => setActive(null);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/careers', label: 'Careers' },
    { path: '/partnerships', label: 'Partnerships' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <Navbar expand="lg" className="custom-navbar py-3 shadow">
      <Container className="d-flex flex-column align-items-center">
        {/* Centered Logo and Title */}
        <div className="text-center">
          <img 
            src={logo} 
            alt="Circle of Care & Wellness Logo" 
            className="logo-img"
          />
          <h1 className="fw-bold text-light fs-3 mt-2">Circle of Care & Wellness</h1>
        </div>

        {/* Centered Hamburger Menu */}
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          className="mx-auto mt-3 custom-toggler" 
        />

        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
          <Nav className="text-center">
            {navLinks.map((link, index) => (
              <Nav.Link 
                key={index} 
                as={Link} 
                to={link.path} 
                className="nav-link-custom position-relative"
                onMouseEnter={() => handleMouseEnter(link.path)}
                onMouseLeave={handleMouseLeave}
                style={{
                  padding: '12px 18px',
                  borderRadius: '8px',
                  fontWeight: '500',
                  fontSize: '1.1rem',
                  backgroundColor: location.pathname === link.path || active === link.path ? '#444' : 'transparent',
                  color: location.pathname === link.path || active === link.path ? 'white' : '#ddd',
                  transition: 'all 0.3s ease',
                  boxShadow: location.pathname === link.path || active === link.path ? '0px 4px 10px rgba(0, 0, 0, 0.2)' : 'none'
                }}
              >
                {link.label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>

      {/* Additional Styling for Navbar */}
      <style>
        {`
          .custom-navbar {
            background-color: #222 !important; /* Darker Background */
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
          }
          .nav-link-custom:hover {
            background-color: #555 !important;
            color: white !important;
          }
          .logo-img {
            width: 180px;
            height: auto;
            display: block;
            margin: 0 auto;
          }
          /* Make the hamburger menu icon white */
          .custom-toggler {
            border-color: rgba(255, 255, 255, 0.8) !important; /* White border */
          }
          .custom-toggler .navbar-toggler-icon {
            filter: invert(1); /* Converts dark icon to white */
          }
        `}
      </style>
    </Navbar>
  );
};

export default Navigation;
